<template functional>
  <div class="user-state-label-wrapper">
    <template v-if="props.status === $options.status().WAITING">
      <i class="el-icon-circle el-icon-time" style="background-color:#00bd83;"></i>
      <span style="color:#00bd83;">待审核</span>
    </template>
    <template v-else-if="props.status === $options.status().UPDATE">
      <i class="el-icon-circle el-icon-time" style="background-color:#00bd83;"></i>
      <span style="color:#00bd83;">个人升级企业认证待审核</span>
    </template>
    <template v-else-if="props.status === $options.status().CERTIFIED">
      <i class="el-icon-circle el-icon-circle-check" style="background-color:#005bff"></i>
      <span style="color:#005bff">认证通过</span>
    </template>
    <template v-else-if="props.status === $options.status().INVALID">
      <i class="el-icon-circle el-icon-circle-close" style="background-color:#FF5753"></i>
      <span style="color:#FF5753">认证失败</span>
    </template>
    <template v-else>
      <i class="el-icon-circle el-icon-remove-outline" style="background-color:#dadde0;"></i>
      <span style="color:#dadde0">未认证</span>
    </template>
  </div>
</template>

<script>
import { STATUS } from '../_eum';
export default {
  name: 'userStateLabel',
  props: {
    status: {
      type: String,
      required: true
    }
  },
  status() {
    return STATUS;
  }
};
</script>

<style lang="scss">
.user-state-label-wrapper {
  display: flex;
  align-items: center;
  // .state-label {
  //   height: 20px;
  //   width: 20px;
  //   padding: 2px;
  //   border-radius: 50%;
  //   line-height: 16px;
  i {
    margin-right: 9px;
  }
  // }
}
</style>
